import { render, staticRenderFns } from "./_voucherRedeemed.vue?vue&type=template&id=992891a4&lang=pug"
import script from "./_voucherRedeemed.vue?vue&type=script&lang=js"
export * from "./_voucherRedeemed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports